import { MemberModel } from '../models/Member.model';
import { MemberDTO, MemberRequestDTO } from '../dtos/Member.dto';
import { GroupUtil } from '../../groups/utils/GroupUtils';

export class MembersUtil {
  public static mapToViewModel(dto: MemberDTO): MemberModel {
    return {
      id: dto.id,
      userId: dto.userId,
      username: dto.userDetails.username,
      email: dto.userDetails.email,
      fullName: dto.userDetails.fullName,
      firstName: dto.userDetails.firstName,
      lastName: dto.userDetails.lastName,
      isDeleted: dto.userDetails.isDeleted ? dto.userDetails.isDeleted : false,
      isEmailVerified: dto.userDetails.isEmailVerified
        ? dto.userDetails.isEmailVerified
        : false,
      lastLogin: dto.userDetails.lastLogin ? dto.userDetails.lastLogin : null,
      groups: dto.groups
        ? dto.groups.map((group) => GroupUtil.mapToViewModel(group))
        : [],
      scope: dto.scope,
      status: dto.status,
    };
  }

  public static toRequestDTO(model?: MemberModel): MemberRequestDTO {
    return {
      id: model ? model.id : undefined,
      email: model ? model.email : '',
      firstName: model ? model.firstName : '',
      lastName: model ? model.lastName : '',
      username: model ? model.username : '',
      groups: model ? model.groups : [],
      scope: model ? model.scope : undefined,
    };
  }
}
